import { render, staticRenderFns } from "./ProfileSelection.vue?vue&type=template&id=40957b42"
import script from "./ProfileSelection.vue?vue&type=script&lang=ts"
export * from "./ProfileSelection.vue?vue&type=script&lang=ts"
import style0 from "./ProfileSelection.vue?vue&type=style&index=0&id=40957b42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports